import React from "react";
import { useSelector } from "react-redux";
import { Typography, TypographyProps } from "@mui/material";
import { RootState } from "store";

interface ProductPriceTagProps {
  productTagPrice: string;
  variant: TypographyProps["variant"]; // 👈  this replaces the old `Variant`
  color?: string | "text.primary";
  salePrice?: number; // Optional prop for sale price
}

const ProductPriceTag: React.FC<ProductPriceTagProps> = ({
  productTagPrice,
  variant,
  color,
  salePrice, // Optional prop for sale price
}) => {
  const selectedCurrency = useSelector(
    (state: RootState) => state.auth.selectedCurrencySymbol,
  );

  const formattedPrice = Number(productTagPrice).toFixed(2);
  const formattedSale =
    salePrice !== undefined ? Number(salePrice).toFixed(2) : undefined;

  return salePrice ? (
    <Typography
      component="span"
      sx={{ display: "flex", alignItems: "baseline", gap: 0.75 }}
    >
      <Typography
        component="span"
        variant={variant}
        sx={{ textDecoration: "line-through", color: "text.secondary" }}
      >
        {formattedPrice} {selectedCurrency}
      </Typography>
      <Typography
        component="span"
        variant={variant}
        sx={{ fontWeight: 900, color: "error.main" }}
      >
        {formattedSale} {selectedCurrency}
      </Typography>
    </Typography>
  ) : (
    <Typography
      component="span"
      variant={variant}
      color={color}
      sx={{ display: "flex" }}
    >
      {formattedPrice} {selectedCurrency}
    </Typography>
  );
};

export default ProductPriceTag;
